import * as Yup from 'yup';

import firstPartyDataSchema from '@components/UserOnboardingModal/ProfileFields/FirstPartyDataSchema';
import type { FirstPartyDataField } from '@components/UserOnboardingModal/ProfileFields/FirstPartyDataSchema';
import { SubscribeSource } from '@utils/backend-api/userOnboarding';

// Fields for promo flow (full set)
const PROMO_FIELDS: FirstPartyDataField[] = [
  'companySize',
  'industry',
  'jobFunction',
  'jobLevel',
  'postalCode',
  'subIndustry',
  'subJobFunction',
];

const PAYWALL_FIELDS: FirstPartyDataField[] = ['industry', 'jobLevel'];

export const getFieldsForSource = (subscribeSource?: SubscribeSource): FirstPartyDataField[] => {
  return subscribeSource === SubscribeSource.PAYWALL ? PAYWALL_FIELDS : PROMO_FIELDS;
};

export const getProfileSchema = (subscribeSource?: SubscribeSource) => {
  const fields = getFieldsForSource(subscribeSource);
  const isPaywall = subscribeSource === SubscribeSource.PAYWALL;

  // Company is required for promo flow, optional for paywall flow
  const companySchema = isPaywall
    ? Yup.object().shape({
        label: Yup.string(),
        value: Yup.string(),
      })
    : Yup.object().shape({
        label: Yup.string().required('Organization is required'),
        value: Yup.string(),
      });

  return Yup.object().shape({
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
    company: companySchema,
    ...firstPartyDataSchema({
      isRequired: true,
      fields,
    }),
  });
};

// Default export for backward compatibility
const profileSchema = getProfileSchema();

export default profileSchema;
